/* global DESKTOP_BREAKPOINT:false */
/* global throttle:false */

(function() {
	var lastHighlightedID;
	var navigation = document.querySelector('.js-scroll-navigation-highlight');

	if (!navigation) {
		return;
	}

	if (window.innerWidth < DESKTOP_BREAKPOINT) {
		return;
	}

	// All menu items
	var menuItems = navigation.querySelectorAll('a');
	var scrollItems = [];

	const stickyHeader = document.getElementById('js-sticky-header');
	const keepFirstItemHighlighted = navigation.getAttribute('data-keep-first-item-highlighted') == 'true' ? true : false;

	function scrollListener() {
		var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

		// Filter out unreached scrollItems
		var reachedItems = Array.prototype.filter.call(scrollItems, function(item) {
			var offset = parseInt(window.innerHeight * 0.33);

			if (stickyHeader) {
				offset += stickyHeader.offsetHeight;
			}

			if (item.offsetTop < scrollTop + offset) {
				return true;
			}
		});

		// Get the id of the current element
		const currentElement = reachedItems[reachedItems.length - 1];
		const currentElementID = currentElement ? currentElement.id : (keepFirstItemHighlighted ? scrollItems[0].id : undefined);

		// Highlight corresponding menu item
		if (lastHighlightedID != currentElementID) {
			lastHighlightedID = currentElementID;

			menuItems.forEach((item) => {
				// Remove highlight from menu items
				item.classList.remove('highlighted');

				if (item.classList.length == 0) {
					item.removeAttribute('class');
				}

				const linkHash = item.href.split('#')[1];

				// Highlight current menu item
				if (linkHash == currentElementID) {
					item.classList.add('highlighted');
				}
			});
		}
	}

	if (menuItems.length > 0) {
		// Anchors corresponding to menu items
		Array.prototype.forEach.call(menuItems, function(item) {
			const linkHash = item.href.split('#')[1];

			if (linkHash) {
				const target = document.getElementById(linkHash);

				if (target) {
					scrollItems.push(target);
				}
			}
		});

		window.addEventListener(
			'scroll',
			throttle(scrollListener, 150, {
				leading: true,
				trailing: true,
			}),
			{
				passive: true,
			}
		);

		// init call on the page load and before first scrolling
		scrollListener();
	}
}());
